import Vue from "vue";
import vuex from "vuex";
Vue.use(vuex);
import { getToken, setToken, removeToken } from "../utils/auth";
import {
  login,
  getDocsList,
  register,
  getAuthCode,
  getResetAuthCode,
  resetPass,
  getDevelopInfo,
  getDashboardStatistics,
} from "@/api/api";

export default new vuex.Store({
  state: {
    showBg: false,
    token: getToken(),
    docsData: {},
    unReadCount: "",
    userInfo: {},
    nameList: {},
  },
  mutations: {
    changeShowBg(state, show) {
      state.showBg = show;
    },
    set_token: (state, token) => {
      state.token = token;
    },
    set_docs: (state, docs) => {
      state.docsData = docs;
    },
    set_unread: (state, num) => {
      state.unReadCount = num;
    },
    set_userInfo: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    setName: (state, list) => {
      state.nameList = list;
    },
  },
  getters: {
    token: (state) => state.token,
  },
  actions: {
    setBg({ commit }, show) {
      commit("changeShowBg", show);
    },

    // 登录
    async login({ commit }, params) {
      try {
        const res = await login(params);
        if (res.code === 0) {
          const data = res.data;
          commit("set_token", data.token);
          setToken(data.token);
        }
        return res;
      } catch (error) {
        console.log(error);
      }
    },

    // 注册
    async register(store, registerInfo) {
      const params = {
        Authorization: "111",
        ...registerInfo,
      };
      try {
        const res = await register(params);
        return res;
      } catch (error) {
        console.log(error);
      }
    },

    // 获取注册验证码
    async getAuthCode(store, params) {
      console.log(params);
      try {
        const res = await getAuthCode(params);
        return res;
      } catch (error) {
        console.log(error);
      }
    },

    // 找回密码验证码
    async getResetAuthCode(store, params) {
      try {
        const res = await getResetAuthCode(params);
        return res;
      } catch (error) {
        console.log(error);
      }
    },

    // 找回密码
    async resetPass(store, params) {
      try {
        const res = await resetPass(params);
        return res;
      } catch (error) {
        console.log(error);
      }
    },

    // 退出登录
    logout({ commit }) {
      commit("set_token", "");
      removeToken();
    },

    // 获取文档
    async getDocsList({ commit }) {
      try {
        const res = await getDocsList();
        let allData = res;

        // 建立名称跟英文名的映射
        let itemObj = {};
        Object.keys(allData).forEach((item) => {
          let docItemArray = allData[item];
          docItemArray.map((docItem) => {
            Object.defineProperty(itemObj, docItem.nameEn, {
              value: docItem.name,
            });
          });
        });
        commit('setName',itemObj);
        commit("set_docs", res);
      } catch (error) {
        console.log(error);
      }
    },

    // 获取未读消息数
    async getDashboardStatistics({ commit }) {
      try {
        const res = await getDashboardStatistics();
        if (res.code === 0) {
          commit("set_unread", res.data && res.data.unreadTotal);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取开发者信息
    async getDevelopInfo({ commit }) {
      try {
        const res = await getDevelopInfo();
        if (res.code === 0) {
          commit("set_userInfo", res.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
});
